import type { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import type { AssetFamily } from '~/modules/artist-roster/lib/types';

interface PreReleaseTooltipContentProps {
  row: Row<AssetFamily>;
}

export function PreReleaseTooltipContent({
  row,
}: PreReleaseTooltipContentProps) {
  const { t } = useTranslation('roster');

  return (
    <div
      className="flex flex-col gap-lg leading-none"
      aria-label={t('preReleases.tooltips.benchmarkTooltip')}
    >
      <span className="font-bold text-strong">{t('preReleases.header')}</span>
      <div className="flex h-full items-center justify-center gap-md">
        <div className="flex flex-col items-start gap-sm">
          <span className="text-caption-md font-semibold">
            {t('preReleases.tooltips.firstWeek')}
          </span>
          {row.original?.benchmark?.firstWeekStreams ? (
            <span className="text-body-md">
              {row.original?.benchmark?.firstWeekStreams.toLocaleString()}
            </span>
          ) : (
            <span className="px-sm py-md pl-md text-subtle">--</span>
          )}
        </div>
        <hr className="h-2xl w-px border-r border-emphasis-subtle" />
        <div className="flex flex-col items-start gap-sm">
          <span className="text-caption-md font-semibold">
            {t('preReleases.tooltips.secondWeek')}
          </span>
          {row.original?.benchmark?.secondWeekStreams ? (
            <span className="text-body-md">
              {row.original?.benchmark?.secondWeekStreams.toLocaleString()}
            </span>
          ) : (
            <span className="text-body-md text-subtle">--</span>
          )}
        </div>
      </div>
    </div>
  );
}

PreReleaseTooltipContent.displayName = 'PreReleaseTooltipContent';
